import MicrobiomeExplorer from "../components/MicrobiomeExplorer";

export default function Explorer() {
  return (
    <div className="page">
      <MicrobiomeExplorer />
    </div>
  );
}

